
import { PropType, defineComponent } from 'vue';

export default defineComponent({
  name: 'PaymentSlot',
  props: {
    cost: {
      type: String,
      required: true
    },
    buttonTitle: {
      type: String,
      required: true
    },
    buttonDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonRed: {
      type: Boolean,
      required: false,
      default: false
    },
    dotPoints: {
      type: Array as PropType<Array<string>>,
      required: false,
      default: []
    },
    hasCounter: {
      type: Boolean,
      required: false,
      default: false
    },
    counterText: {
      type: String,
      required: false,
      default: ''
    },
    onButtonClick: {
      type: Function as PropType<() => string>,
      required: false,
      default: () => {}
    },
    counter: {
      type: Number,
      required: false,
      default: 0
    },
    setCounter: {
      type: Function as PropType<(count: number) => string>,
      required: false,
      default: () => {}
    }
  },
  methods: {
    onCancelSubscription() {
      this.$emit('onCancelSubscription');
    }
  }
});
